import { Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ThousandSeparatorDirective } from './utils/separator.directive';

@Component({
  selector: 'app-pharmacy-quota',
  imports: [ReactiveFormsModule, ThousandSeparatorDirective],
  templateUrl: './pharmacy-quota.html',
  styleUrl: './pharmacy-quota.scss',
})
export class PharmacyQuota {
  pharmacyForm = input.required<FormGroup>();
}
